import React, {useEffect, useState} from 'react';
import {useIsMount} from "../../hooks";

import {
    InputForm
} from "../InputForm";

const AddressFinderFilter = ({ data, onFilterChange, language }) => {
    const isMount = useIsMount();
    const filterSettings = data[1];
    const filterType = filterSettings.type;
    const filterAttributes = filterSettings.attributes || {};

    const [checkboxChecked, setCheckboxChecked] = useState(data[1].checked)
    const [inputValue, setInputValue] = useState(filterType === "queryParam" ? filterSettings.queryParam : filterSettings.value)

    const handleOnFilterChangeCallback = (value) => {
        if (onFilterChange) {
            onFilterChange(data[1], checkboxChecked, value)
        }
    }

    useEffect(()=>{
        if (!isMount) {
            handleOnFilterChangeCallback(inputValue)
        }
    },[checkboxChecked, inputValue])

    const resolveFilterType = (filter) => {
        const inputBlock = [];
        const checkbox = (
            <InputForm
                type={'checkbox'}
                key={0}
                checked={checkboxChecked}
                onChange={(e)=>{
                    setCheckboxChecked(e.target.checked)
                }}
            >
                <span className="font-size-13">
                    {filter[0][language]}
                </span>
            </InputForm>
        )

        switch(filterType) {
            case "queryParam": {
                inputBlock.push(
                    checkbox
                )
            }
            break;
            case "queryParamWithInput": {
                inputBlock.push(
                    checkbox
                )
                inputBlock.push(
                    <InputForm
                        key={1}
                        className={'filter-wrapper__additional-block'}
                        size={'sm'}
                        type={'text'}
                        disabled={!checkboxChecked}
                        value={data[1].value}
                        onChange={(e)=>{
                            setInputValue(e.target.value)
                        }}
                    />
                )
            }
            break;
        }

        return inputBlock
    }

    const classNames = ["filter-wrapper","d-flex","align-items-center"]
    if (filterAttributes.className) {
        classNames.push(filterAttributes.className);
        delete filterAttributes.className;
    }

    return (
        <>
            {filterAttributes.breakRow && <div style={{width: "100%", display: "block"}}/>}
            <div className={classNames.join(" ")}>
                {resolveFilterType(data)}
            </div>
        </>
    )
}

export default AddressFinderFilter;